import { Injectable } from "@angular/core";
import { Http, Response, RequestOptions, Request, Headers, ResponseContentType, ResponseOptions } from '@angular/http';
import { global } from '../../models/global';
import { Observable } from "rxjs";
import { updateStatus } from "src/app/Models/Admin/production-approval";

@Injectable({
    providedIn: 'root'
  })

export class ProductionApprovalService {
  ROOT_URL: string = "";
  
  constructor(private http: Http) {
    let g: global = new global();
    this.ROOT_URL = g.getApiUrl();
  }

  artworkProductionFilters(): Observable<any> {
    let userID = localStorage.getItem('mcmt_userId');
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'GET',
      url: this.ROOT_URL + "/api/ProductionApproval/ArtworkProductionFilters?userID=" + userID,
      headers: headers
    })

    return this.http.request(new Request(requestoptions))
      .map((res: Response) => {
        return res.json();
      });

  }

  artworkProductionDetails(jobNumber: string, name: string, type: string, brand: string, crop: string, language: string, status: any, month: string, state: string): Observable<any> {
    let _body = {
      "UserID": localStorage.getItem('mcmt_userId'),
      "JobNumber": jobNumber,
      "RMHName": name,
      "JobType": type,
      "Brand": brand,
      "Crop": crop,
      "Language": language,
      "OrderStatus": status,
      "Month": month,
      "State": state
    }

    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: this.ROOT_URL + "/api/ProductionApproval/ArtworkProductionDetails",
      headers: headers,
      body: _body
    })

    return this.http.request(new Request(requestoptions))
      .map((res: Response) => {
        return res.json();
      });

  }

  downloadExcel(jobNumber: string, name: string, type: string, brand: string, crop: string, language: string, status: any, month: string, state: string,Vendor: string): Observable<any> {
    let _body = {
      "UserID": localStorage.getItem('mcmt_userId'),
      "JobNumber": jobNumber,
      "RMHName": name,
      "JobType": type,
      "Brand": brand,
      "Crop": crop,
      "Language": language,
      "OrderStatus": status,
      "Month": month,
      "State": state,
      "Vendor": Vendor
    }
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: this.ROOT_URL + "/api/ProductionApproval/DownloadProductionApprovalExcel",
      headers: headers,
      body: _body,
      responseType: ResponseContentType.Blob
    })
    return this.http.request(new Request(requestoptions))
      .map((res: Response) => {
        var blob = new Blob([res.blob()], { type: 'xlsx' })
        return blob;
      });
  }

  uploadArtworkProduction(documents: File): Observable<any> {
    const formData = new FormData();
    formData.append("file", documents);
    formData.append("UserId", localStorage.getItem('mcmt_userId'));

    let headers = new Headers({ 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
    let requestoptions: RequestOptions = new RequestOptions({
      headers: headers
    })
    return this.http.post(this.ROOT_URL + "/api/ProductionApproval/UploadArtworkProduction", formData, requestoptions)
      .map((res: Response) => {
        return res.json();
      });
  }

  updateArtworkProduction(updateArtworkProduction: updateStatus[]): Observable<any> {
    let _body = {
      "UserID": localStorage.getItem('mcmt_userId'),
      "JobNumber": updateArtworkProduction
    }

    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: this.ROOT_URL + "/api/ProductionApproval/UpdateArtworkProduction",
      headers: headers,
      body: _body
    })

    return this.http.request(new Request(requestoptions))
      .map((res: Response) => {
        return res.json();
      });

  }
}

